import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=6586d156&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=6586d156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586d156",
  null
  
)

export default component.exports